enum qCustomColors {
  successLight = "#4CAF50",
  warningDark = "#E65100",
  purpleLight = "#E7E1F2",
  purpleLight2 = "#EFECF3",
}

export default qCustomColors;
